import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { OrganizationApi } from 'api';

function useDelete() {
  const queryClient = useQueryClient();
  return useAuthMutation((id: number) => OrganizationApi.del(id), {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getQueryKeys([KEY]).all });
    },
  });
}

export default useDelete;
